import type { IconData } from '@stacksjs/iconify-core'

export const suitcaseRolling: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M37.725 38.024c-.16 2.557-2.09 4.525-4.647 4.701c-2.14.147-5.132.275-9.078.275s-6.938-.128-9.078-.275c-2.556-.176-4.487-2.144-4.647-4.701C10.13 35.714 10 32.414 10 28s.13-7.714.275-10.024c.16-2.557 2.09-4.525 4.647-4.701C17.062 13.128 20.054 13 24 13s6.938.128 9.078.275c2.556.176 4.486 2.144 4.647 4.701c.145 2.31.275 5.61.275 10.024s-.13 7.714-.275 10.024\"/><path d=\"M30.971 13.153a255 255 0 0 0-.144-6.206c-.072-1.97-1.382-3.607-3.345-3.794C26.547 3.063 25.392 3 24 3a37 37 0 0 0-3.482.153c-1.963.187-3.273 1.824-3.346 3.794a255 255 0 0 0-.144 6.206M37.94 33H10.06M16 43v3m16-3v3\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default suitcaseRolling
